import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

// Assets generated by design agent
export const ASSETS = {
  bg: {
    ring: "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/040d4504ec4fcaa4d651303ace10636cb6f427e9a658e6043421924b2d33bfd5.png",
    shop: "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/14a47f4267295da2094b94f8e88dc23947ed54cd2c4ab646fa2c89bdfdca5cf3.png",
    training: "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/428066b0e2ee10c23dade263250df8cb57be3ff3330433ed8afb19dd4deb5fb8.png",
  },
  avatars: [
    "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/30bd9ccd5cf361e9250a64d5662ca1acde047ab22e9ec07459e0c3399bcde302.png",
    "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/da442bb351fd937352ee56a6837cf11b6ffc537b5fcf0c0ef2b3c040539cd0ae.png",
  ],
  currency: {
    hotdog: "/ui/Hotdog_Currency_Icon.webp",
    handshake: "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/f97376f61a303b74853162963ef2282371c5fe4e446eae550d720a181db5c854.png",
    fan: "https://static.prod-images.emergentagent.com/jobs/b66f27cb-f526-4ba8-afe8-b4509811391b/images/42ddbf388193d3dbf14795557930a7a00593f5c7d3fdd06cd8d064237acd73da.png",
  },
};

export function avatarFor(idx) {
  return ASSETS.avatars[(idx - 1) % ASSETS.avatars.length];
}

export function wrestlerAvatar(w) {
  if (!w || !w.wrestler_id) return "";
  const v = w.avatar_updated_at ? new Date(w.avatar_updated_at).getTime() : 0;
  return `${API}/wrestlers/${w.wrestler_id}/avatar?v=${v}`;
}

export function playerAvatar(account_name, updated_at) {
  if (!account_name) return "";
  const v = updated_at ? new Date(updated_at).getTime() : 0;
  return `${API}/players/${encodeURIComponent(account_name)}/avatar?v=${v}`;
}

export function promotionAvatar(promotion_id, updated_at) {
  if (!promotion_id) return "";
  const v = updated_at ? new Date(updated_at).getTime() : 0;
  return `${API}/promotions/${encodeURIComponent(promotion_id)}/avatar?v=${v}`;
}
